import { render, staticRenderFns } from "./Loc.vue?vue&type=template&id=64ecaad7&scoped=true"
import script from "./Loc.vue?vue&type=script&lang=js"
export * from "./Loc.vue?vue&type=script&lang=js"
import style0 from "./Loc.vue?vue&type=style&index=0&id=64ecaad7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ecaad7",
  null
  
)

export default component.exports